/* src/config/store.js */

/* global window */
/* eslint no-underscore-dangle: off */

import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { createLogger } from 'redux-logger';

import { middleware } from './middleware';
import rootReducer from './reducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default (history, preloadedState) => {
  const middlewares = [
    middleware(),
    routerMiddleware(history),
    process.env.NODE_ENV === 'development' && createLogger(),
    // createLogger(),
  ].filter(Boolean);
  const store = createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(...middlewares),
  );

  return { store };
};



// WEBPACK FOOTER //
// ./src/config/store.js